import { action, computed, makeObservable, observable } from "mobx";
import { IStoreElement } from "types/store";
import { setBodyOverflow } from "helpers/dom";

enum Target {
  menuMobileOpen = "menuMobileOpen",
  catalogMobileOpen = "catalogMobileOpen",
  stickyMenuMobile = "stickyMenuMobile",
  categoryMobileFilterOpen = "categoryMobileFilterOpen",
}

export interface IHeader extends IStoreElement {
  menuMobileOpen: boolean;
  catalogMobileOpen: boolean;
  stickyMenuMobile: boolean;
  categoryMobileFilterOpen: boolean;
  stickyHeader: boolean;
  openMenuMobile: () => void;
  openCatalogMobile: () => void;
  openCategoryMobileFilter: () => void;
  open: (target: Target) => void;
  close: (target: Target) => void;
  closeAllMenus: () => void;
  toggleStickyHeader: (value: boolean) => void;
}

export default class Header implements IHeader {
  @observable menuMobileOpen = false;
  @observable catalogMobileOpen = false;
  @observable categoryMobileFilterOpen = false;
  @observable stickyMenuMobile = false;
  @observable stickyHeader = false;

  constructor() {
    makeObservable(this);
  }

  @action
  openMenuMobile(): void {
    setBodyOverflow("hidden");
    this.close(Target.catalogMobileOpen);
    this.open(Target.menuMobileOpen);
  }

  @action
  openCatalogMobile(): void {
    setBodyOverflow("hidden");
    this.close(Target.menuMobileOpen);
    this.open(Target.catalogMobileOpen);
  }

  @action
  openCategoryMobileFilter(): void {
    this.open(Target.categoryMobileFilterOpen);
  }

  @action
  closeAllMenus(): void {
    setBodyOverflow("auto");
    this.close(Target.menuMobileOpen);
    this.close(Target.catalogMobileOpen);
    this.close(Target.stickyMenuMobile);
    this.close(Target.categoryMobileFilterOpen);
  }

  @action
  toggleStickyHeader(value: boolean): void {
    this.stickyHeader = value;
  }

  @action
  open(target: Target): void {
    this[target] = true;
  }

  @action
  close(target: Target): void {
    this[target] = false;
  }
}
